module.exports = __webpack_public_path__ + "static/media/loading.09fec537.gif";